import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, FileSpreadsheetIcon, FileTextIcon, ClipboardCheckIcon, CalendarDaysIcon } from 'lucide-react';
const bonuses = [{
  title: '📊 Bono 1 — Planilla de seguimiento semanal (Google Sheets)',
  icon: FileSpreadsheetIcon,
  image: 'https://cdn.magicpatterns.com/uploads/2Jiiim14smZNpLaASb8pUr/Screenshot_2026-06-17_at_12.10.49_AM.png',
  description: 'Registrá cada sesión, medí tus avances y visualizá tu progreso semana a semana. Con totales automáticos y autoevaluación integrada.'
}, {
  title: '📋 Bono 2 — Checklist de calentamiento y vuelta a la calma (PDF)',
  icon: FileTextIcon,
  image: 'https://cdn.magicpatterns.com/uploads/vxH7YKyR3HQGBhMjciH4Wp/Screenshot_2026-06-17_at_12.12.25_AM.png',
  description: 'El protocolo completo para antes y después de cada entrenamiento o partido. Calentamiento general, movilidad articular, activación específica y elongación post-sesión.'
}, {
  title: '✅ Bono 3 — Test de evaluación inicial de habilidades (PDF)',
  icon: ClipboardCheckIcon,
  image: 'https://cdn.magicpatterns.com/uploads/hyAckzgJUoM7pq9STidSiJ/Screenshot_2026-06-17_at_12.13.04_AM.png',
  description: 'Conocé tu punto de partida real antes de arrancar. Autoevaluación técnica en 7 habilidades clave, condición física percibida y objetivos para las 8 semanas. Repetilo al finalizar para medir tu mejora.'
}, {
  title: '📅 Bono 4 — Plan de 8 semanas editable (Google Sheets)',
  icon: CalendarDaysIcon,
  image: 'https://cdn.magicpatterns.com/uploads/agYYZ5yp4Mi4XrCZ1ZwGpR/Screenshot_2026-06-17_at_12.13.42_AM.png',
  description: 'La progresión completa de Base a Pico de rendimiento, semana por semana, con objetivos técnicos, físicos y tácticos para cada etapa. Listo para personalizar.'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-orange-50 py-12 md:py-16 px-4" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-14">
            De regalo con tu compra
          </h2>
          <p className="text-lg text-orange-600 font-semibold" data-id="element-15">
            🎁 Bonos GRATIS solo por hoy
          </p>
        </motion.div>

        <div className="space-y-4 mb-10" data-id="element-16">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-gradient-to-r from-orange-50 to-blue-50 rounded-lg shadow-md overflow-hidden border-2 border-orange-200 hover:border-orange-400 transition-colors" data-id="element-17">
                <div className="relative h-44 md:h-52 w-full overflow-hidden" data-id="element-18">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-top" data-id="element-19" />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-blue-900/20 to-transparent" data-id="element-20" />
                </div>
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 text-left hover:bg-orange-100/50 transition-colors" data-id="element-21">
                  <div className="flex items-center gap-3" data-id="element-22">
                    <Icon className="w-6 h-6 text-blue-600 flex-shrink-0" data-id="element-23" />
                    <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-24">
                      {bonus.title}
                    </h3>
                  </div>
                  <ChevronDownIcon className={`w-6 h-6 text-orange-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-25" />
                </button>

                <AnimatePresence data-id="element-26">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-27">
                      <div className="p-5 pt-0 border-t border-orange-200" data-id="element-28">
                        <p className="text-gray-700" data-id="element-29">{bonus.description}</p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl font-bold text-center text-gray-900 leading-relaxed" data-id="element-30">
          Dentro de 8 semanas vas a jugar el mismo básquet de siempre o uno
          completamente diferente.{' '}
          <span className="text-orange-500" data-id="element-31">Depende de vos.</span>
        </motion.p>
      </div>
    </section>;
}